import React from "react";
import "./Shop.css";
import Footer from "../../components/Footer/Footer";

const Shop = () => {
  return (
    <>
      <section id="shop" className="shop-section">
        <h2>Shop Coming Soon</h2>
        <p>
          Exclusive music lesson materials and gear will be available here soon.
        </p>

        {/* Optional CTA to add a little more presence */}
        <p className="shop-cta">
          <a href="/contact">Notify me when it launches</a>
        </p>
      </section>

      <Footer />
    </>
  );
};

export default Shop;
